module.exports = __webpack_public_path__ + "static/img/cp_1.28830f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hs/cp_1.png
// module id = sHFn
// module chunks = 1